exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion[data-v-25b77d0e]{width:100%}.accordion .accordion-trigger[data-v-25b77d0e]{width:100%;cursor:pointer}.accordion .accordion-body[data-v-25b77d0e]{overflow:hidden}.accordion .accordion-trigger-icon[data-v-25b77d0e]{height:100%;transform:rotate(0deg);transition:transform .25s ease}.is-active .accordion-trigger-icon[data-v-25b77d0e]{transform:rotate(180deg)}.accordion-enter-active[data-v-25b77d0e],.accordion-leave-active[data-v-25b77d0e]{will-change:height;transition:height .25s ease}.accordion-enter[data-v-25b77d0e],.accordion-leave-to[data-v-25b77d0e]{height:0!important}", ""]);

// exports
